module.exports = __webpack_public_path__ + "img/ico_back.308f2bbd.svg";